import { render, staticRenderFns } from "./WarrantyPeriod.vue?vue&type=template&id=18a72bc5&"
import script from "./WarrantyPeriod.vue?vue&type=script&lang=js&"
export * from "./WarrantyPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports